import Singleplayer from "./Singleplayer";

const TicTacToe = () => {
  return <Singleplayer />;
};

export default TicTacToe;
